/**
 * Created by coolguy on 2018/8/30.
 */
import { observable, action } from 'mobx';
import { arrDiff } from '../utils/util';
import commentApi from '../actions/videoComment';
import RootStore from './RootStore';
import { IResult } from '../global';

class VideoCommentStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }
  @observable commentList = [] as any[];
  @observable commentTop = [] as any[];
  @observable commentTotal = 0;
  @observable commentTopTotal = 0;
  @observable finished = false;
  @observable lastTime = Number.MAX_SAFE_INTEGER;
  @observable minCreateTime = new Date().getTime(); // 最小的创建时间，注意，加载更多是加载老的评论，而默认的刷新是加载最新的评论
  @action addOne(one: any) {
    this.commentList = [one, ...this.commentList];
    this.commentTotal++;
  }

  @action deleteOneById = (id: number) => {
    if (!id) {
      return;
    }
    const index = this.commentList.findIndex((one: any) => one.id == id);
    if (index !== -1) {
      this.commentList = [
        ...this.commentList.slice(0, index),
        ...this.commentList.slice(index + 1)
      ];
    }
  };

  getTop(galleryId: string) {
    return commentApi.top(galleryId).then(
      action((jsonData: any) => {
        if (jsonData && jsonData.data) {
          this.commentTop = jsonData.data;
          this.commentTopTotal = (jsonData.data || []).length;
          return this.commentTop;
        }
      })
    );
  }

  getList(galleryid: string, videoId: string) {
    return commentApi.list(galleryid, videoId, this.lastTime).then(
      action((jsonData: any) => {
        if (jsonData && jsonData.data) {
          const sublength = jsonData.data.length;
          const { total } = jsonData;
          this.commentTotal = total;
          // console.log(total);
          //现在有前端的前置评论了，必须得考虑去重问题
          this.commentList = [
            ...arrDiff(this.commentList.slice(), jsonData.data, (a1, a2) => {
              return a1.id === a2.id;
            }),
            ...jsonData.data
          ];
          const { length } = this.commentList;
          // 认定如果返回的数量是0 或者返回的数量和 commentList一样 说明已经加载完所有评论
          // （不考虑后来新增的评论，反正不定期的在刷新评论）
          if (length === total || sublength < 50) {
            this.finished = true;
          }
          if (length) {
            // this.lastTime = this.commentList[0].createtime || 0;
            this.minCreateTime = this.commentList[length - 1].createtime;
            this.lastTime = this.commentList[length - 1].createtime;
          }
          //console.log(this.commentList.slice())
          return this.commentList;
        }
      })
    );
  }
  @action clear() {
    this.lastTime = Number.MAX_SAFE_INTEGER;
    this.minCreateTime = Date.now();
    this.commentList = [];
  }
}

export default VideoCommentStore;
